module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-a-cropped.4edb756f.jpg";